







import { Component, Vue } from 'vue-property-decorator';
import Menu from '@/components/Menu.vue';
import {isMobile} from '@/scripts';

@Component({
  components: {
    Menu
  },
})
export default class Home extends Vue {
  public isMobile = isMobile;
}
